import { initGrid } from 'utils/grid/grid';
import isEmpty from 'lodash/isEmpty';

import { fetchMessagesList, markMessageAsUnread, markMessageAsRead, resetInbox, deleteMessages } from 'message/actions/inbox.actions';
import {
  onMessageSelection,
  toggleSelectAllMessagesPointer,
  clearSelectedMessagesList,
  setSelectAllPointerStatus,
} from 'message/actions/selected-messages.actions';
import { fetchUnreadMessagesCount } from 'message/actions/unread-count.actions';
import { checkAccess } from 'app/actions/app.actions';

import { selectedMessageDetailsSelector } from 'selectors/index';

import template from './messages-list.html';

const mapStateToThis = (state) => {
  const { session, messages, ui, config } = state;
  const { locale } = session;
  const { inbox, inboxLoadingStatus: isLoading, selectedMessages } = messages;
  const { pagination } = ui;
  const { defaultPageSizes, sortColumnKey, pageSizeKey, directionKey } = config;
  const { selectedMessagesList, hasAllMessagesSelected } = selectedMessages;

  return {
    locale,
    messages: inbox,
    isLoading,
    pagination,
    selectedMessagesList,
    hasAllMessagesSelected,
    pageSizeKey,
    sortColumnKey,
    directionKey,
    defaultPageSize: defaultPageSizes[2],
    selectedMessage: selectedMessageDetailsSelector(state),
  };
};

const mapDispatchToThis = {
  fetchMessagesList,
  deleteMessages,
  markMessageAsUnread,
  markMessageAsRead,
  fetchUnreadMessagesCount,
  onMessageSelection,
  toggleSelectAllMessagesPointer,
  clearSelectedMessagesList,
  setSelectAllPointerStatus,
  resetInbox,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$state', '$ngRedux', 'Notifications', 'messageDefinitionService')
class MessagesListController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.canCreateMessage = this.checkAccess('message.create');

    this.fetchUnreadMessagesCount();
    this.headers = this.getHeaders();
    this.defaultParams = {
      [this.sortColumnKey]: 'inAppMessage.sendDate',
      [this.directionKey]: false,
      [this.pageSizeKey]: this.defaultPageSize,
    };
    this.gridModel = initGrid(this.fetchMessagesList, this.defaultParams);

    this.search();
  }

  $onDestroy() {
    this.clearSelectedMessagesList();
    this.resetInbox();
    this.unsubscribe();
  }

  async onDeleteMessage() {
    await this.deleteMessages();
    this.Notifications.alertSuccess(this.messageDefinitionService.get('MSGS_DELETE', 'desc'));

    this.search();
  }

  search() {
    this.gridModel.applyFilters();
  }

  getHeaders() {
    return [
      {
        text: this.messageDefinitionService.get('FROM', 'desc'),
        field: 'inAppMessage.authorName',
        sortable: true,
      },
      {
        text: this.messageDefinitionService.get('SUBJECT_AND_PREVIEW', 'desc'),
        field: 'inAppMessage.subject',
        sortable: true,
      },
      {
        text: this.messageDefinitionService.get('DATE', 'desc'),
        field: 'inAppMessage.sendDate',
        sortable: true,
        textAlignment: 'text-right',
      },
    ];
  }

  canReply() {
    if (isEmpty(this.selectedMessage) || this.selectedMessagesList.length !== 1) return false;

    return this.selectedMessage.allowReply;
  }

  replyMessage() {
    this.Notifications.showComplexDialog({
      backdrop: 'static',
      component: 'replyMessageDialog',
    });
  }

  viewMessage(id) {
    this.$state.go('message.view', { id });
  }

  toggleSelectAllMessages() {
    const messagesList = this.messages.map(({ userMessageId }) => userMessageId);
    this.toggleSelectAllMessagesPointer(messagesList);
  }

  selectMessage(id) {
    this.onMessageSelection(id);
    const hasAllMessagesSelected = this.messages.length === this.selectedMessagesList.length;
    this.setSelectAllPointerStatus(hasAllMessagesSelected);
  }

  isSelected(id) {
    return this.selectedMessagesList.includes(id);
  }
}

export default class MessagesListComponent {
  constructor() {
    this.controller = MessagesListController;
    this.template = template;
    this.transclude = true;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/message/components/messages-list/messages-list-component.js